export default __webpack_public_path__ + "static/media/2062.f26313a4.png";